import React, { useContext, useEffect, useRef, useState } from "react";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import SideBarMenu from "../../Components/SideBarMenu";
import ErrorField from "../../Components/ErrorField";
import { AppContext } from "../../Contexts/AppContextProvider";
import {
    HTTPResponse,
    SideMenuItems,
    ToastMessages,
    ToastMessageType,
    Values,
} from "../../Helpers/Enums";
import {
    CommonError_Msgs, hyperlinkTextMDEs,
} from "../../Helpers/HelperText";
import InfoPopUp from "../../Components/InfoPopUp";
import {
    GetLocalStorageData,
    GetLoggedInUserID,
    IsAdmin,
    applySidebarState,
    toggleSidebar,
} from "../../Helpers/Utilities";

import { MDEFormService } from "../../WebApiServices/MDEForm.service";

const MDESForm = () => {
    const { ShowToast, ToggleLoader, HandleSessionTimeout, isSideMenuActive, setisSideMenuActive, appState, SetMDENo } =
        useContext(AppContext);

    const navigatePaths = {
        prevPage: "/MDEInfo",
        currPage: "/MDESForm",
        nextPage: appState?.mdeNo > 0 ? "/MDESInformation/1" : "/Hospitalizations"
    };
    const pidRef = useRef(0);
    const [showTopErrMsg, setShowTopErrMsg] = useState(false);
    const [showHideHyperlinkModalS2, setShowHideHyperlinkModalS2] = useState(false);

    const oneYrTransplantStart = "1-year pre-transplant start";
    const twoYrPostStabilization = "24-month post-stabilization date";
    let localStorageWithDatesValues = GetLocalStorageData("ClinicalCharacteristicsDates") || [];

    const [mdeDetails, setMdeDetails] = useState({
        patientId: 0,
        experience_mde: 0,
    });

    const InitialHardErrList = {
        //1
        experience_empty: false,
    };
    const [hardErrList, setHardErrList] = useState(InitialHardErrList);
  const [patientLocked, setpatientLocked] = useState(false);
    // useEffect(() => {
    //     async function FetchData() {
    //         pidRef.current = GetLocalStorageData("patientId") || 0;
    //         if (pidRef.current !== 0) {
    //             ToggleLoader(true);
    //             await LoadData();
    //             ToggleLoader(false);
    //         }

    //     }
    //     FetchData();
    // }, []);

    //SYJ 23/04/2025 - Jenkins warning Fix
    useEffect(() => {
        pidRef.current = GetLocalStorageData("patientId") || 0;
        if (pidRef.current !== 0) {
            LoadData();
        }
    }, []);

    async function LoadData() {
        try {
            ToggleLoader(true);
            const response = await MDEFormService.LoadMDEFormData(pidRef.current);
            if (response?.status === HTTPResponse.OK) {
                const { data } = response;
                setpatientLocked(data.patientLocked);
                SetFields(data);
                ToggleLoader(false);
            } else {
                ToggleLoader(false);
                if (response?.status === HTTPResponse.Unauthorized) {
                    HandleSessionTimeout();
                } else {
                    throw response.error;
                }
            }
        } catch (error) {
            ToggleLoader(false);
            ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
        }
    }

    const SetFields = (data) => {
        setMdeDetails((prev) => {
            return {
                ...prev,
                //Q27
                patientId: pidRef.current,
                experience_mde: data.experience_mde
            };
        });
    };

    const SavePage = async (validate) => {
        try {
            if (!patientLocked) {
                //Reset Errors
                setHardErrList(InitialHardErrList);
                let isValid = validate ? Validate() : true;
                if (!isValid) {
                    setShowTopErrMsg(true);
                    return false;
                }
                setShowTopErrMsg(false);

                if (pidRef.current > 0) {
                    const payload = {
                        PatientId: pidRef.current,
                        UserId: GetLoggedInUserID(),
                        IsValidated: validate,
                        IsAdmin: IsAdmin(),
                        Experience_mde: mdeDetails.experience_mde,
                    };
                    ToggleLoader(true);
                    const response = await MDEFormService.SaveMDEFormData(payload);
                    ToggleLoader(false);
                    if (response.status !== HTTPResponse.OK) {
                        if (response?.status === HTTPResponse.Unauthorized) {
                            HandleSessionTimeout();
                        } else throw response.error;
                    } else {
                        ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
                        if (response) {
                            const { data } = response;

                            if (data) {
                                SetFields(data);
                                LoadData();
                            }
                        }
                    }
                }
            }
            return true;
        } catch (error) {
            ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
        }
    };

    const Validate = () => {
        let isValid = true;

        let experience_empty = false;

        if (mdeDetails.experience_mde === null || mdeDetails.experience_mde === 0) {
            experience_empty = true;
        }

        setHardErrList((prev) => ({
            ...prev,
            experience_empty
        }));

        if (experience_empty) {
            isValid = false;
        }
        return isValid;
    };

    const HandleFieldChange = (e) => {
        const { value } = e.target;

        setMdeDetails((prevDetails) => ({
            ...prevDetails,
            experience_mde: parseInt(value, 10), // Ensure it's stored as a number
        }));
        if (parseInt(value, 10) === Values.value2)
            SetMDENo(1);
        else if (parseInt(value, 10) === 1)
            SetMDENo(0);


        setHardErrList((prev) => ({
            ...prev,
            experience_empty: false,
        }));
    };

    useEffect(() => {
        applySidebarState(isSideMenuActive);
    }, [isSideMenuActive]);

    return (
        <>
            <section className="survey-patient-details-section">
                <div className="row">
                    <PatientDetails />
                    <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
                        <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
                    </div>
                </div>
            </section>

            <section className="main-survey-section main-survey-button">
                <div >
                    <SideBarMenu activePageId={SideMenuItems.MDESForm} />
                    <>
                        <button className={isSideMenuActive ? "openbtn" : "openbtn active"}
                            onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
                        >
                            <i
                                id="arrowNavigation"
                                className="fa fa-arrow-left"
                                aria-hidden="true"
                            ></i>
                        </button>
                    </>
                    <div className=" col-pad-left eligibiltylocked" id="main">
                        <div className="survey-section-content" id="contentsec">
                            <div className="survey-section-content-header">
                                <h4>MDES FROM {localStorageWithDatesValues.oneYr_pretransplant_start || oneYrTransplantStart} TO {localStorageWithDatesValues.twenty_four_months_post_stabilization || twoYrPostStabilization}</h4>
                            </div>
                            {showTopErrMsg && (
                                <div className="clean-error ">
                                    <ErrorField
                                        show={showTopErrMsg}
                                        message={CommonError_Msgs.Hard_Empty}
                                    />
                                </div>
                            )}

                            <div className="survey-question-section" disabled={patientLocked}>
                                <div className="survey-question-content survey-content-box grey-bg">
                                    <div className="question-answer grid-overflow">
                                        <div className="block-margin">
                                            <div>
                                                <div className="custom-table">
                                                    <table className="border-table-fifty">
                                                        <tr>
                                                            <td className="containertd">
                                                                <div className="question question-weight">
                                                                    <span>Q27.</span>
                                                                    <span className="quest-text-pad">
                                                                        Did the patient experience at least 1{" "}
                                                                        <span
                                                                            data-tooltip-id="encounterTip"
                                                                            className="modal-popup"
                                                                            onClick={() => setShowHideHyperlinkModalS2(true)}
                                                                        >
                                                                            metabolic decompensation events (MDEs)
                                                                        </span>{" "}
                                                                        {showHideHyperlinkModalS2 && (
                                                                            <InfoPopUp
                                                                                description={hyperlinkTextMDEs}
                                                                                OkClick={() => setShowHideHyperlinkModalS2(false)}
                                                                            />
                                                                        )}{" "} within 12 months prior to and 27 months after the index date
                                                                        (from <span className="indigo-text">
                                                                            {localStorageWithDatesValues.oneYr_pretransplant_start || oneYrTransplantStart}
                                                                        </span>{" "}
                                                                        to{" "}
                                                                        <span className="indigo-text">
                                                                            {localStorageWithDatesValues.twenty_four_months_post_stabilization || twoYrPostStabilization}
                                                                        </span>)?
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td className="containertd">
                                                                <div>
                                                                    <div className="option-without-input">
                                                                        <label>
                                                                            <input
                                                                                type="radio"
                                                                                id="experience_mde_1"
                                                                                name="experience_mde_1"
                                                                                value={1}
                                                                                checked={
                                                                                    mdeDetails.experience_mde === 1
                                                                                }
                                                                                onChange={HandleFieldChange}
                                                                            />
                                                                            <span className="radio-text-padding">
                                                                                No
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="option-without-input">
                                                                        <label>
                                                                            <input
                                                                                type="radio"
                                                                                id="experience_mde_2"
                                                                                name="experience_mde_2"
                                                                                value={2}
                                                                                checked={
                                                                                    mdeDetails.experience_mde === Values.value2
                                                                                }
                                                                                onChange={HandleFieldChange}
                                                                            />
                                                                            <span className="radio-text-padding">
                                                                                Yes
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <ErrorField
                                                                    show={hardErrList.experience_empty}
                                                                    message={CommonError_Msgs.Msg1}
                                                                />
                                                            </td>
                                                        </tr>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="survey-section-content-foot">
                                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
                            </div>

                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default MDESForm;
